import React from 'react';
import { AutocompleteInput } from 'react-admin';

class DivisionSelectInput extends React.Component {
    constructor(props) {
        super(props);

        this.getSuggestions().then(data => {
            this.setState({
                choices: data,
                loaded: true
            });
        });

        this.state = {
            choices: [],
            loaded: false
        };
    }

    getSuggestions = async () => {
        let response = await fetch(
            process.env.REACT_APP_API_ENTRYPOINT + "/divisions/short-list?range=[0,999]",
            {headers: {
                    'Accept': 'application/json',
                    'Authorization': 'Basic ' + process.env.REACT_APP_API_TOKEN,
                    'x-session': localStorage.getItem('session')
                }}
        );

        return await response.json()
    }

    render() {
        return (
            <AutocompleteInput
                source={this.props.source}
                label={this.props.label}
                validate={this.props.validate}
                choices={this.state.choices || []}
                {...this.props}
            />
        );
    }
}

export default DivisionSelectInput;
